import { Image } from '@slot-nx/core'
import { Container } from '@pixi/react'
import { Container as PixiContainer } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { backgroundService } from '../domain/background'
import { gameConfig } from '../config'

export const DesktopBackground = () => {
  const desktopBgRef = useRef<PixiContainer>()
  useEffect(() => {
    backgroundService.desktopBg = desktopBgRef.current as PixiContainer
  }, [])

  return (
    <Container
      name="DesktopBackground"
      x={0}
      y={0}
      ref={((el: PixiContainer | null) => {
        desktopBgRef.current = el as PixiContainer
      })}
    >
      <Image
        name="fg"
        image="desktopBGFG"
        width={3240}
        height={1920}
        x={gameConfig.resolution.width / 2}
        y={gameConfig.resolution.height / 2}
        anchor={[0.5, 0.5]}
      />
      <Image
        name="mg"
        image="desktopBGMG"
        width={3240}
        height={1920}
        x={gameConfig.resolution.width / 2}
        y={gameConfig.resolution.height / 2}
        anchor={[0.5, 0.5]}
      />
    </Container>
  )
}
